var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import classNames from 'classnames';
import { Table } from 'antd';
import AirPagination from 'air-pagination';
import isFunction from 'lodash';
import './AirTable.css';

var AirTable = function (_Component) {
  _inherits(AirTable, _Component);

  function AirTable(props) {
    _classCallCheck(this, AirTable);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.componentDidUpdate = function (prevProps, prevState) {
      if (_this.props.pagination && _this.props.pagination.current !== prevProps.pagination.current) {
        _this.setState({
          currentPage: _this.props.pagination.current
        });
      }
    };

    _this.nextPage = function () {
      var currentPage = _this.state.currentPage;
      var _this$props = _this.props,
          dataSource = _this$props.dataSource,
          pagination = _this$props.pagination,
          virtualDataSource = _this$props.virtualDataSource,
          virtualDataSourceCount = _this$props.virtualDataSourceCount;
      var lastPage = void 0;

      if (typeof virtualDataSource !== 'undefined') {
        lastPage = Math.ceil(virtualDataSourceCount / pagination.pageSize);
      } else {
        lastPage = Math.ceil(dataSource.length / pagination.pageSize);
      }

      if (currentPage < lastPage) {
        _this.setState({
          currentPage: _this.state.currentPage + 1
        }, function () {
          typeof _this.props.onPageChange === 'function' && _this.props.onPageChange(_this.state.currentPage);
        });
      }
    };

    _this.prevPage = function () {
      var currentPage = _this.state.currentPage;

      if (currentPage > 1) {
        _this.setState({
          currentPage: _this.state.currentPage - 1
        }, function () {
          typeof _this.props.onPageChange === 'function' && _this.props.onPageChange(_this.state.currentPage);
        });
      }
    };

    _this.onSelectChange = function (selectedRowKeys) {
      _this.setState({
        selectedRowKeys: selectedRowKeys
      }, function () {
        if (_this.props.rowSelection && isFunction(_this.props.rowSelection.onChange)) {
          _this.props.rowSelection.onChange(selectedRowKeys);
        }
      });
    };

    _this.onSelectAll = function (selected) {
      var selectedRowKeys = selected ? _this.props.dataSource.map(function (item) {
        return item[_this.props.rowKey || 'key'];
      }) : [];

      _this.setState({
        selectedRowKeys: selectedRowKeys
      }, function () {
        if (_this.props.rowSelection && isFunction(_this.props.rowSelection.onSelectAll)) {
          _this.props.rowSelection.onSelectAll(selectedRowKeys);
        }
      });
    };

    _this.state = {
      currentPage: _this.props.defaultCurrent || 1,
      selectedRowKeys: []
    };
    return _this;
  }

  AirTable.prototype.componentDidMount = function componentDidMount() {
    if (this.props.pagination && this.props.pagination.current) {
      this.setState({
        currentPage: this.props.pagination.current
      });
    }
  };

  AirTable.prototype.render = function render() {
    var _classNames;

    var _props = this.props,
        columns = _props.columns,
        pagination = _props.pagination;
    var currentPage = this.state.currentPage;
    var dataSource = typeof this.props.virtualDataSource !== 'undefined' ? this.props.virtualDataSource : this.props.dataSource;
    var total = typeof this.props.virtualDataSource !== 'undefined' ? this.props.virtualDataSourceCount : this.props.dataSource.length;
    var cls = classNames((_classNames = {
      AirTable: true
    }, _classNames[this.props.className] = !!this.props.className, _classNames));
    var selectedRowKeys = this.state.selectedRowKeys;
    return React.createElement('div', {
      className: cls
    }, pagination && pagination.position && ['both', 'top'].includes(pagination.position) && React.createElement('div', {
      style: {
        display: 'flex',
        justifyContent: 'flex-end'
      }
    }, React.createElement(AirPagination, {
      currentPage: currentPage || 1,
      pageSize: pagination.pageSize || 7,
      next: this.nextPage,
      prev: this.prevPage,
      total: total
    })), React.createElement(Table, _extends({}, this.props, {
      columns: columns,
      dataSource: dataSource,
      rowClassName: 'AirTableRow',
      pagination: {
        pageSize: pagination.pageSize,
        current: currentPage,
        hideOnSinglePage: true
      },
      rowSelection: this.props.rowSelection !== false ? _extends({
        selectedRowKeys: selectedRowKeys,
        onSelectAll: this.onSelectAll instanceof Function ? this.onSelectAll : undefined,
        onChange: this.onSelectChange instanceof Function ? this.onSelectChange : undefined
      }, this.props.rowSelection) : null
    })), pagination && pagination.position && ['both', 'bottom'].includes(pagination.position) && React.createElement('div', {
      style: {
        display: 'flex',
        justifyContent: 'flex-end'
      }
    }, React.createElement(AirPagination, {
      currentPage: currentPage || 1,
      pageSize: pagination.pageSize || 7,
      next: this.nextPage,
      prev: this.prevPage,
      total: total
    })));
  };

  return AirTable;
}(Component);

export { AirTable as default };